"use client";
import SearchInput from "@/app/component/search_input";
import { FBProductType } from "@/app/data/passticket_type";
import { useEffect, useState } from "react";
import { fetchDataPassTickets } from "../../component/get_rates";
import { usePathname, useSearchParams } from "next/navigation";
import PassTicketsLoading from "./loading";
import PassTicketsComponent from "@/app/component/passticket_component";

export default function PassTicketsSubPage() {
  const searchParams = useSearchParams();
  const [datas, setDatas] = useState<Array<FBProductType>>([]);
  const [filteredDatas, setFilteredDatas] = useState<Array<FBProductType>>([]);
  const [stateArea, setStateArea] = useState<string>(searchParams.get("area") || "");
  const [stateName, setStateName] = useState<string>(searchParams.get("name") || "");

  var target = "";
  const currentPage = usePathname();

  const [isNothing, setIsNothing] = useState<boolean>(false);

  const [areaName, setAreaName] = useState("");
  const isApp = searchParams.get("isApp") || "";

  useEffect(() => {
    target = currentPage.replace("/", "");

    if (target !== "") {
      getDatas();
    }

    switch (stateArea) {
      case "osaka":
        setAreaName("오사카");
        break;
      case "tokyo":
        setAreaName("도쿄");
        break;
      case "kyushu":
        setAreaName("큐슈");
        break;
      case "hokkaido":
        setAreaName("홋카이도");
        break;
      case "okinawa":
        setAreaName("오키나와");
        break;
      default:
        break;
    }
  }, []);

  const getDatas = async () => {
    if (stateArea !== "" && target !== "") {
      const serverDatas = await fetchDataPassTickets(stateArea, target);
      setDatas([...serverDatas]);
      setFilteredDatas([...serverDatas]);

      if (stateName !== "") {
        // 여기서 datas는 서버에서 받은 datas 
        const filterDatasKr = serverDatas.filter((item) => item.kr.includes((stateName)));

        const findIndex = serverDatas.findIndex((item) => item.kr.includes((stateName)));

        const newArr = serverDatas.filter((_, index) => index !== findIndex);

        const filterDatasEn = serverDatas.filter((item) => item.en.toLowerCase().includes((stateName.toLowerCase())));
        const dupArr = [...filterDatasKr, ...filterDatasEn];
        const resultDatas = dupArr.filter((element, index) => {
          return dupArr.indexOf(element) === index;
        });
        setFilteredDatas([...resultDatas, ...newArr]);
      }
    }
  }

  const getInputStr = (search: any) => {
    setIsNothing(false);
    if (search.length === 0) {
      setFilteredDatas([...datas]);
    } else {
      setTimeout(() => {
        setIsNothing(true);
      }, 1000);
    }

    const filterDatasKr = datas.filter((item) => item.kr.includes((search)));
    const filterDatasEn = datas.filter((item) => item.en.toLowerCase().includes((search.toLowerCase())));
    const dupArr = [...filterDatasKr, ...filterDatasEn];
    const resultDatas = dupArr.filter((element, index) => {
      return dupArr.indexOf(element) === index;
    });
    setFilteredDatas([...resultDatas]);
  }

  return <>

    <div className="container prose prose-lg dark:prose-invert !max-w-screen-md mx-auto dark:prose-dark space-y-4">

      {isApp ? <div className="pt-1"></div> : <h2 className="pt-6 mb-3">{areaName} 할인 패스/티켓</h2>}

      <div className="text-xs text-neutral-500 font-light">
        <p>
          아래 요금은 업데이트 시점이나 환율 등으로 인해 실제 상품 금액과 다를 수 있으며 상품의 대표 요금이 명시되어 있으며, 배너를 통해 상품 구매 시 발생한 수수료로 더 좋은 서비스를 제공합니다.
        </p>
      </div>

      <SearchInput initValue={stateName} datas={filteredDatas} childParent={getInputStr} />

      {(filteredDatas.length === 0 && isNothing === false) ? PassTicketsLoading()
        : <></>
      }

      {(filteredDatas.length === 0 && isNothing === true) ?
        <p className="text-sm text-neutral-500 font-light">검색 결과가 없습니다.</p> : <></>
      }

      {
        filteredDatas.map((item) => (
          <div className="w-full mt-3" key={item.id}>
            <PassTicketsComponent area={stateArea} items={filteredDatas} itemId={item.id} isProduct={false} />
          </div>
        ))
      }

      {/* {filteredDatas.length === 0 ? <></> : <p className="text-xs mt-5 text-neutral-400/65">
        배너를 통해 상품 구매 시 일정액의 수수료를 제공받을 수 있습니다.
      </p>} */}
    </div>
  </>;
}